import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import { Link } from "react-router-dom";
import Leftpanel from "../../layout/Leftpanel";
import Countrycurrency from "./Countrycurrency";
// import flagIconCss from 'https://cdn.skypack.dev/flag-icon-css';
import {
  getCurrency,
  getAllCurrencylist,
  deleteCurrency,
  getAllCurrencyData,
  setDefaultCurrency,
} from "../../../../service/Currency/CurrencyService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Currency = () => {
  const { t } = useTranslation();
  const [currency, setCurrency] = useState("");
  const [status, setStatus] = useState(false);
  const [show, setShow] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [currencyList, setAllCurrencyList] = useState([]);
  const [deleteCurrencyId, setDeleteCurrencyId] = useState("");
  const [currencyData, setAllCurrencyData] = useState("");

  const handleClose = () => setShow(false);
  const handleCloseDelete = () => setShowDelete(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();

  const onCurrency = (e) => {
    setCurrency(e.target.value);
    // console.log(e.target.value, "currency")
  };
  const onDelete = (data) => {
    setDeleteCurrencyId(data);
    // console.log(data,"datadatadatadatadatadata")
    setShowDelete(true);
  };

  const onAdd = () => {
    if (currency === "") {
      toast.error("Please select currency");
    } else {
      getCurrency(currency, (r) => {
        setStatus(r.success);
        setShow(false);
        getCurrencyDataList();
        console.log(r, "response");
        if (r.success === true) {
          toast.success(r.message);
          setCurrency("");
          navigate("/currency");
        } else {
          setShow(true);
          toast.error(r.message);
        }
      });
    }
  };
  const onAddCurrency = () => {
    setShow(true);
  };

  const onYes = () => {
    deleteCurrency(deleteCurrencyId, (res) => {
      // console.log(res, "response")
      if (res.success === true) {
        toast.success(res.message);
        setShowDelete(false);
        getCurrencyDataList();
      } else {
        toast.error(res.message);
      }
    });
  };

  const onNo = () => {
    setShowDelete(false);
  };

  useEffect(() => {
    getCurrencyDataList();
  }, []);

  async function getCurrencyDataList() {
    getAllCurrencylist().then(function (result) {
      // console.log(result?.data, "datadatadatadatada")
      const response = result?.data;

      setAllCurrencyList(response?.data?.currencyList);
    });
  }

  useEffect(() => {
    getCurrencyData();
  }, []);

  async function getCurrencyData() {
    getAllCurrencyData().then(function (result) {
      // console.log(result.data, "datadatadatadatada")
      const response = result.data;
      // console.log(response, "rrrr")
      setAllCurrencyData(response?.data?.availablecurrencyList);
    });
  }

  let currencyDropdown = <option>Loading...</option>;
  if (currencyData && currencyData.length > 0) {
    currencyDropdown = currencyData.map((currencyRow, index) => (
      <option value={currencyRow?.name}>{currencyRow?.name}</option>
    ));
  }

  const _SET_DEFAULT_CURRENCY = async (e, currencyId) => {
    e.preventDefault();
    setDefaultCurrency(currencyId, (res) => {
      getCurrencyDataList();
      toast.success(res.message);
    });
  };

  return (
    <div className="container-fluid">
      <div className="dbMain currencyBg">
        <Leftpanel breadcm="Other" />
        <div className="dbRight">
          <Header
            link="/dashboard"
            title={t("currency_configuration")}
            description=""
          />
          <div className="commonBase mb-4">
            <div className="dbtableTop">
              <div className="dbSearch">
                <h6>{t("add_new_currency")}</h6>
              </div>
              <div className="dbtableSrchbg">
                <button className="commonButton" onClick={onAddCurrency}>
                  <Link to="">
                    <i className="fa-solid fa-plus"></i> {t("add")}
                  </Link>
                </button>
              </div>
            </div>
            <div className="dbMaintable currencyTable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("currency_name")}</th>
                    <th>&nbsp;</th>
                    <th>{t("action")}</th>
                    <th>{t("default_currency")}</th>
                  </tr>
                </thead>
                <tbody>
                  {currencyList?.map((d, index) => (
                    <tr key={index}>
                      <td data-label={t("currency_name")}>{d?.name}</td>
                      <td data-label="">&nbsp;</td>
                      <td data-label={t("action")}>
                        <i
                          className="fa-solid fa-trash-can"
                          onClick={onDelete.bind(null, d?.id)}
                        ></i>
                      </td>
                      <td>
                        <input
                          type="radio"
                          name="defaultCurrency"
                          id={index}
                          onChange={(e) => _SET_DEFAULT_CURRENCY(e, d?.id)}
                          checked={d?.defaultCurrency}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Add Currency Modal */}
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>{t("select_currency")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-3 row">
                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  {t("select_currency")}
                </label>
                <div className="col-sm-10">
                  <select className="form-control" onChange={onCurrency}>
                    <option value="">{t("select")}</option>
                    {currencyDropdown}
                  </select>
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="primary"
                className="commonButton"
                onClick={onAdd}
              >
                {t("add")}
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDelete} onHide={handleCloseDelete} centered>
            <Modal.Header closeButton className="pb-0 border-0">
              {/* Optional Title */}
            </Modal.Header>
            <Modal.Body className="text-center pt-0">
              <h3 className="pb-2">{t("delete_confirmation")}</h3>
              <Button
                variant="primary"
                className="commonButton"
                onClick={onYes}
              >
                {t("yes")}
              </Button>
              &nbsp; &nbsp;
              <Button variant="primary" className="commonButton" onClick={onNo}>
                {t("no")}
              </Button>
              &nbsp; &nbsp;
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Currency;
